import { Box, SxProps, Theme } from '@mui/material';
import { FunctionComponent, PropsWithChildren } from 'react';

interface FetchMoreWrapperProps {
  className?: string;
  sx?: SxProps<Theme>;
}

export const FetchMoreWrapper: FunctionComponent<PropsWithChildren<FetchMoreWrapperProps>> = ({
  className,
  children,
  sx,
}) => (
  <Box
    className={className}
    sx={{
      margin: 'auto',
      display: 'flex',
      justifyContent: 'center',
      maxWidth: { xs: 'max-content', md: '100%' },
      width: { xs: 'auto', md: '100%' },
      ...(sx || {}),
    }}
  >
    {children}
  </Box>
);
